import React, { Component } from 'react';
import { connect } from 'react-redux';

import HeadingBox from '../../UI/Headings/HeadingBox/HeadingBox';
import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2'
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import InputMaterial from '../../UI/InputMaterial/InputMaterial';
import Button from '../../UI/Button/Button';
import TextSpinner from '../../UI/TextSpinner/TextSpinner';
import TooltipError from '../../UI/TooltipError/TooltipError';

import OTPImageEmail from './img/email-otp-background.png';
import OTPImageMobile from './img/mobile-otp-background.png';

import SmallButton from '../../Travellers/TravellerButton/TravellerButton';

import * as authActions from '../../../store/actions/index';

class AuthOTP extends Component {

    state = {
        userOTP: '',
        resendOTP: false,
        intervalTime: 60,
        otpMode: 'Mobile'
    }

    switchOTPModeHandler = (mode) => {
        this.setState({
            otpMode: mode
        })
    }

    componentWillMount() {
        this.interval = setInterval(() => {
            this.setState(prevState => {
                return { intervalTime: prevState.intervalTime - 1 }
            });
            if (this.state.intervalTime === 0) {
                clearInterval(this.interval);
                this.setState({
                    resendOTP: true,
                    intervalTime: 0
                })
            }
        }, 1000);
    }

    inputChangeHandler = (event) => {
        this.setState({
            userOTP: event.target.value
        })
    }

    resendOTPTimeout = () => {
        this.setState({
            resendOTP: false,
            intervalTime: 60
        }, () => {
            let interval = setInterval(() => {
                this.setState(prevState => {
                    return { intervalTime: prevState.intervalTime - 1 }
                });
                if (this.state.intervalTime === 0) {
                    clearInterval(interval);
                    this.setState({
                        resendOTP: true,
                        intervalTime: 0
                    })
                }
            }, 1000);
        });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    keyPressHandler = (event) => {
        let interactionId = null;

        if (this.state.otpMode === 'Email') {
            interactionId = this.props.interactionIds.Email;
        } else {
            interactionId = this.props.interactionIds.Mobile;
        }
        if(event.key === 'Enter') {
            this.props.onGetVerifyOTP(this.state.otpMode, this.state.userOTP, interactionId, this.props.ssoToken);
        }
    }

    render() {

        let interactionId = null;

        if (this.state.otpMode === 'Email') {
            interactionId = this.props.interactionIds.Email;
        } else {
            interactionId = this.props.interactionIds.Mobile;
        }

        const border = '1px solid var(--color-border)';

        return (
            <React.Fragment>
                <div className={`mb-6 u-phoneTextAlignCenter`}>
                    <HeadingBox>
                        <div className="mb-1">
                            <HeadingH2 size={26} weight="Regular" color="Dark">Verify OTP</HeadingH2>
                        </div>
                        <HeadingH3 size={13} weight="Regular" color="Light">An OTP (valid for next 15mins) has been sent on your registered Email and Mobile Number</HeadingH3>
                    </HeadingBox>
                </div>
                <div className={`u-flex justify-content-center align-items-center mb-4 u-height160`}>
                    <img src={this.state.otpMode === 'Mobile' ? OTPImageMobile : OTPImageEmail} alt="OTP Login" className={`u-width100Percent`}/>
                </div>
                <div className={`u-flex align-items-center mb-4`}>
                    <SmallButton isactive={this.state.otpMode === 'Mobile' ? 'true' : 'false'} onClick={() => this.switchOTPModeHandler('Mobile')}>Mobile</SmallButton>
                    <SmallButton isactive={this.state.otpMode === 'Email' ? 'true' : 'false'} onClick={() => this.switchOTPModeHandler('Email')}>Email</SmallButton>
                </div>
                <div className={`u-flex justify-content-center align-items-center u-height60 mb-6 u-relative`}>
                    <TooltipError showTooltip={this.props.otpError} type="loginError" aria-label={'Wrong OTP'} />
                    <InputMaterial 
                        type='text' 
                        alignment='left' 
                        label='Enter OTP' 
                        value={this.state.userOTP} 
                        onChange={this.inputChangeHandler}
                        onKeyPress={this.keyPressHandler}
                        style={{borderBottom: this.props.otpError ? '2px solid #FC1D00' : `${border}`}}/>
                </div>
                <div className={`u-textAlignCenter u-flex align-items-center jutify-content-between mb-6 phone-justify-content-center`}>
                    <p>{ !this.state.resendOTP ? 'Your OTP will expire in ' + this.state.intervalTime + ' Sec' : 'Your OTP has been expired' }</p>
                    <span>&nbsp;|&nbsp;</span>
                    <button 
                        style={{ color: !this.state.resendOTP ? '#666' : '#4570F5' }}
                        onClick={() => {
                            this.props.onGetResendOTP(this.props.interactionIds)
                            this.resendOTPTimeout();
                        }} className={`u-cursorPointer u-fontWeightRegular u-fontSize13 u-border0 u-outline0 u-textColorNormal`} 
                        disabled={!this.state.resendOTP}>Resend OTP &nbsp;
                    </button>
                </div>
                <div className={`mb-6`}>
                    <Button theme='Primary' type='Submit' width='Block' onClick={() => this.props.onGetVerifyOTP(this.state.otpMode, this.state.userOTP, interactionId, this.props.ssoToken)}>{this.props.otpLoading ? <TextSpinner type='White'/> : 'Submit'}</Button>
                </div>
                <div className={`u-textAlignCenter`}>
                    <span className={`u-textColorPrimary u-fontWeightMedium u-textUppercase u-cursorPointer`} onClick={() => {
                        this.props.onStopAuthentication();
                        this.props.onSetAuthView('home');
                    }}>CANCEL</span>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        otpLoading: state.auth.otpLoading,
        email: state.auth.email,
        otpError: state.auth.otpError,
        interactionIds: state.auth.interactionIds,
        ssoToken: state.auth.ssoToken
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGetVerifyOTP: (otpMode, userOTP, interactionId, ssoToken) => dispatch(authActions.getVerifyOTP(otpMode, userOTP, interactionId, ssoToken)),
        onGetResendOTP: (interactionIds) => dispatch(authActions.getResendOTP(interactionIds)),
        onSetAuthView: (authView) => dispatch(authActions.setAuthView(authView)),
        onStopAuthentication: () => dispatch(authActions.stopAuthentication()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthOTP);


// WEBPACK FOOTER //
// ./src/components/Authentication/AuthOTP/AuthOTP.js